export enum MessageProcessorPipelineEvent {
  USER_MESSAGE_CREATED = 'USER_MESSAGE_CREATED',
}

export interface MessageProcessorPipelinePayload {
  event: MessageProcessorPipelineEvent.USER_MESSAGE_CREATED;
  chatMessageId: string;
  chatId: string;
}
